export interface OrderOwner {
  readonly email?: string;
  readonly name: string;
}

export const unknownOwner = {
  name: 'Not Assigned',
};
